import React from 'react';
import Axios from 'axios';
import {
  Card,
  CardHeader,
  CardBody,
  CardFooter, 
  Collapse,
  Tooltip
} from 'reactstrap';
import AutoSuggestPlayer from '../../shared/AutoSuggest/AutoSuggestPlayer';
import CountUp, { useCountUp } from 'react-countup';

import moment from 'moment';
import Users from '../../users/Users';

import MontQvneaPlayerProgramsModal from './MontQvneaPlayerProgramsModal';

const autoSuggTheme = {
	container: 'react-autosuggest-std__container',
	input: 'react-autosuggest-std__input',
	inputOpen: 'react-autosuggest-std__input--open',
	inputFocused: 'react-autosuggest-std__input--focused',
	suggestionsContainer: 'react-autosuggest-std__suggestions-container',
	suggestionsContainerOpen: 'react-autosuggest-std__suggestions-container--open',
	suggestionsList: 'react-autosuggest-std__suggestions-list',
	suggestion: 'react-autosuggest-std__suggestion',
	suggestionHighlighted: 'react-autosuggest-std__suggestion--highlighted',
	//suggestionFirst: 'react-autosuggest__suggestion--first',
	//sectionContainer: 'react-autosuggest__section-container',
	//sectionContainerFirst: 'react-autosuggest__section-container--first',
	//sectionTitle: 'react-autosuggest__section-title'
};

const ADMIN_LVL_MASTER = 0;				// same as Users.js
const ADMIN_LVL_ADMINLIMIT = 20;	// same as Users.js

const cstTableHeaders = ['Rang', 'Joueur', 'Altitude'];	//, 'Semaine', 'Mois'];
const cstDefaultSortOrder = ['', 'asc', 'desc'];	//, 'desc', 'desc'];
const cstDefaultSortFieldIdx = 2;
const cstTablePlayerIdColIdx = 5;

class MontQvnea extends React.Component {

  constructor(props) {
		super(props);

		this.state = {
			// admin players
	    isAuthenticated: this.props.auth.isAuthenticated(),
			profile: this.props.auth.getProfile(),
			adminAccess: {
				auth: this.props.auth,
				globalAccessLevel: 99,
				adminValidatedAccessLevel: 99		// not used here
			},
			isAdmin: false,

			selectedYear: 0,
			playerSearchId: "0",

			yearTotalMeters: 0,
			showCountUp: false,

			mqYears: [],
			mqYear: {
				headerLogo: "",
				levels: []
			},
			mqTableData: [],
			sortFieldIdxs: [],
			sortOrders: [],
			visibleLevels: [],
			levelDataLoaded: [],

			showPlayerProgramsModal: false,
			programsModalPlayer: {
				_id: '0',
				name: ''
			},

			loading: true,
		};

    this.displayDataLevel = this.displayDataLevel.bind(this);
    this.toggleLevel = this.toggleLevel.bind(this);
    this.createHdrRow = this.createHdrRow.bind(this);
    this.handleYearChange = this.handleYearChange.bind(this);
    this.handleSortTable = this.handleSortTable.bind(this);
    this.createTableRow = this.createTableRow.bind(this);
    this.handleModalCancel = this.handleModalCancel.bind(this);
 		this.handlePlayerChange = this.handlePlayerChange.bind(this);
 		this.handleSearchPlayer = this.handleSearchPlayer.bind(this);
	}

	componentDidMount() {
		// console.log('MontQvnea: componentDidMount');
		this.initiateData();
	}

	UNSAFE_componentWillReceiveProps() {
		// console.log('MontQvnea: UNSAFE_componentWillReceiveProps');
	}

	initiateData() {
		var _this = this;

		// get admin rights
		this.getAdminRightsInfo(function(adminAccess) {

			// isAdmin status
	  	var isAdmin = (adminAccess.globalAccessLevel <= ADMIN_LVL_ADMINLIMIT);

			_this.setState({
				adminAccess: adminAccess,
				isAdmin: isAdmin,
			});

			Axios.get('/api/qvnea/montQvneaYears').then(function(mqYearsResponse) {
				var mqYears = mqYearsResponse.data;
				_this.loadLevels(mqYears, mqYears[0].value);
			});
		});
	}

	loadLevels(mqYears, selectedYear) {
  	// parse levels to show the ones that are visible at start
		var _this = this;

		Axios.get('/api/qvnea/montQvneaSummary/year/' + selectedYear).then(function(mqSummaryYearResponse) {
		Axios.get('/api/qvnea/montQvneaYearTotalMeters/' + selectedYear).then(function(mqSummaryResponse) {

			// console.log('loadLevels')
			// console.log(mqSummaryYearResponse.data)
			// console.log(mqSummaryResponse.data)

			var mqYear = mqSummaryYearResponse.data;

			var mqTableData = [];
			var sortFieldIdxs = [];
			var sortOrders = [];
			var visibleLevels = [];
			var levelDataLoaded = [];
			mqYear.levels.forEach(ld => {
				mqTableData.push([]);		// push empty levels in mqTableData
				sortFieldIdxs.push(cstDefaultSortFieldIdx);
				sortOrders.push(cstDefaultSortOrder[cstDefaultSortFieldIdx]);
				visibleLevels.push(false);
				levelDataLoaded.push(false);
			});

			if (visibleLevels.length > 0) {
				visibleLevels[0] = true;		// at least one visible
			}

			_this.setState({
				mqYears: mqYears,
				mqYear: mqYear,
				mqTableData: mqTableData,
				sortFieldIdxs: sortFieldIdxs,
				sortOrders: sortOrders,
				visibleLevels: visibleLevels,
				levelDataLoaded: levelDataLoaded,
				showCountUp: true,
				yearTotalMeters: mqSummaryResponse.data.totalMeters
			});

			visibleLevels.forEach(function (visibleLevelStatus, visibleLevelIdx) {
				if (visibleLevelStatus === true) {
					_this.loadLevel(mqTableData, selectedYear, visibleLevelIdx, "0");
				}
			});
		});
		});
	}

	loadLevel(mqTableData, selectedYear, level, playerSearchId) {
		var _this = this;

		Axios.get('/api/qvnea/montQvneaLevelSummary/year/' + selectedYear + '/level/' + level).then(function(mqSummaryResponse) {

			var mqTableDataLevel = mqSummaryResponse.data;

			mqTableData[level] = [];
			mqTableDataLevel.forEach(function (mqDataRow, mqDataRowIdx) {

				var mqTableDataLevelRow = [];
				mqTableDataLevelRow.push(0);
				mqTableDataLevelRow.push(mqDataRow.playerName);
				mqTableDataLevelRow.push(mqDataRow.metersTotal);
				mqTableDataLevelRow.push(mqDataRow.metersWeek);
				mqTableDataLevelRow.push(mqDataRow.metersMonth);
				mqTableDataLevelRow.push(mqDataRow.playerId);

				mqTableData[level].push(mqTableDataLevelRow);
			});

			// console.log('mqTableData', mqTableData)
			_this.sortLevel(mqTableData, selectedYear, level, _this.state.sortFieldIdxs, _this.state.sortOrders, playerSearchId);
		});
	}

	sortLevel(mqTableData, selectedYear, level, sortFieldIdxs, sortOrders, playerSearchId) {

		var _this = this;
		var levelDataLoaded = this.state.levelDataLoaded;
		levelDataLoaded[level] = true;

		var sortFieldIdx = sortFieldIdxs[level];
		var sortOrder = sortOrders[level];

		var sortSign = 1;
		if (sortOrder === 'desc') { 
			sortSign = -1; 
		}

		// Sort data level
		mqTableData[level].sort(function (a, b) {

			var valueA = 0;
			var valueB = 0;

			var fact1 = 0;
			var fact2 = 0;

			// Criteria #1
			valueA = a[sortFieldIdx];
			valueB = b[sortFieldIdx];

			switch(typeof valueA) {
		    case "date":
					fact1 = sortSign * (new Date(valueA) - new Date(valueB));
					fact2 = (a[1].localeCompare(b[1]));
	        break;

		    case "string":
					fact1 = sortSign * (valueA.localeCompare(valueB));
					fact2 = 0;
  	      break;

		    case "number":
					fact1 = sortSign * (valueA - valueB);
					fact2 = (a[1].localeCompare(b[1]));
	        break;

		    default:
	        break;
			}

			// Results
			if (fact1 !== 0) {
				return fact1;
			} else {
				return fact2;
			}
		});

		// Do we have to focus on one player in search box ?
		if (playerSearchId !== "0") {

			// get player row
			var mqTableDataLevel = mqTableData[level];
			var playerRowIdx = 0;
			for (var tableIdx = 0; tableIdx < mqTableDataLevel.length; tableIdx++) {
				if (mqTableDataLevel[tableIdx][cstTablePlayerIdColIdx] === playerSearchId) {
					playerRowIdx = tableIdx;
					break;
				}
			}

			var collapseElement = document.getElementById("collapse." + level);
			var rowElementId = "tablerow." + level + "." + playerRowIdx;

			if (collapseElement.className === "collapse show") {

				var elements = document.getElementsByClassName('highlightTableRow');
				while(elements.length > 0){
		  		elements[0].classList.remove('highlightTableRow');
				}

				var rowElement = document.getElementById(rowElementId);
				rowElement.classList.add('highlightTableRow');
				rowElement.scrollIntoView({behavior: "smooth", block: 'center'});

			} else {
				document.addEventListener('collapse-shown', function(event) {
					// console.log("collapse-shown!!")

					var elements = document.getElementsByClassName('highlightTableRow');
					while(elements.length > 0){
			  		elements[0].classList.remove('highlightTableRow');
					}

					var rowElement = document.getElementById(rowElementId);
					rowElement.classList.add('highlightTableRow');
					rowElement.scrollIntoView({behavior: "smooth", block: 'center'});
				});
			}
		}

		_this.setState({
			selectedYear: selectedYear,
			mqTableData: mqTableData,
			sortFieldIdxs: sortFieldIdxs,
			sortOrders: sortOrders,

			levelDataLoaded: levelDataLoaded,
			loading: false
		});

	}

  toggleLevel(level) {
  	var visibleLevels = this.state.visibleLevels;
  	var levelDataLoaded = this.state.levelDataLoaded;

  	visibleLevels[level] = !visibleLevels[level];

  	if (visibleLevels[level] && !levelDataLoaded[level]) {
  		this.loadLevel(this.state.mqTableData, this.state.selectedYear, level, "0");
  	}

    this.setState({
    	visibleLevels: visibleLevels
    });
  }

  openLevel(level, playerSearchId) {
  	var visibleLevels = this.state.visibleLevels;
  	var levelDataLoaded = this.state.levelDataLoaded;

  	visibleLevels[level] = true;
  	//if (visibleLevels[level] && !levelDataLoaded[level]) {
  		this.loadLevel(this.state.mqTableData, this.state.selectedYear, level, playerSearchId);
  	//}

    this.setState({
    	visibleLevels: visibleLevels
    });
  }

	render() {
		//console.log('MontQvnea: render');
		//console.log('profile: ' + this.state.profile.name + '(' + this.state.profile.user_id + ')');
		//console.log('globalAccessLevel: ' + this.state.adminAccess.globalAccessLevel);
		//console.log('isAdmin: ' + this.state.isAdmin.toString());
		//console.log(this.state.mqYear);
		//console.log(this.state.mqTableData);

		var _this = this;
		return (
			<div className="animated fadeIn">
        <div className="row">
        <div className="col-md-8 col-xs-12">
          <h4>Mont-QVNEA</h4>
          <p>LA PUISSANCE DES STATS</p>
	        <hr/>

	        {(this.state.mqYear.headerLogo !== "") ?
		      <div className="col-md-4 col-xs-12 text-center only-on-mobile">
						<a href="http://qvnea.com/mont-qvnea" target="_blank">
						<img className="img-fluid" src={this.state.mqYear.headerLogo} alt="mq-logo" width="275"/><br/><br/>	
						</a>
		      </div>
		      : null}

          <h5>Programme de récompenses de la QVNEA</h5>
        	<ul className="ul-left-aligned">
        		<li>Gravir le Mont QVNEA en participant aux activités de la QVNEA</li>
        		<li>Atteindre des niveaux de récompenses sous forme de bourses et de cadeaux</li>
        		<li>Obtenir des chances de remporter le Mont Jackpot</li>
	       		<li>Cliquer sur l'entête d'une table pour consulter la liste des joueurs qui ont atteint ce dernier</li>
	       		<li>Cliquer sur le nom d'un joueur pour voir le détails de son ascension !</li>
        	</ul>

					<div className="row">
					<div className="col-md-6 col-12">
  	      	{this.dispYearsSelector()}
    	    	<br/>
      	  	{this.dispPlayerSearch()}
					</div>
					<div className="col-md-6 col-12">
						{this.state.showCountUp ? this.dispTotalCount() : null}
					</div>
					</div>
        	<br/>

        </div>

        {(this.state.mqYear.headerLogo !== "") ?
        <div className="col-md-4 col-xs-12 text-center not-on-mobile">
					<a href="http://qvnea.com/mont-qvnea" target="_blank">
					<img className="img-fluid" src={this.state.mqYear.headerLogo} alt="mq-logo" width="275"/><br/><br/>	
  				</a>
        </div>
        : null}

        </div>

				<div className="row">
				<div className="col-md-12">
					{this.displayModule()}
				</div>
				</div>

				<br/><br/><br/>

				{/* Modal */}
				<MontQvneaPlayerProgramsModal 
					className = {this.props.className}
					showModal = {this.state.showPlayerProgramsModal}
					handleModalCancel = {this.handleModalCancel}
					programsModalPlayer = {this.state.programsModalPlayer}
					years = {this.state.mqYears}
					selectedYear = {this.state.selectedYear}
					mqLevels = {this.state.mqYear.levels}
				/>
      </div>
		);
	}

	dispYearsSelector() {
		return (
			<div className="row">
      <div className="col-12">
			<span className=""> <strong> Choisir une saison </strong> </span> <br/>
			<select className="form-control" type="text" id="seasonYears" value={this.state.selectedYear} 
				onChange={this.handleYearChange}>
	    	{this.state.mqYears.map((y, yidx) => (
	    		<option key={'yearSelOpt.' + yidx} value={y.value}> {'Saison ' + y.dropdownText} </option> ))}
			</select>
			</div>
			</div>
		)					
	}

	dispPlayerSearch() {
		return (
			<div className="row">
      <div className="col-12">
				<span className=""> <strong> Rechercher un joueur </strong> </span> <br/>
				<AutoSuggestPlayer theme={autoSuggTheme} playerId={this.state.playerSearchId} 
					dataChange={this.handlePlayerChange} />
				<button className="btn btn-primary btn-margin-topbottom-10" onClick={this.handleSearchPlayer}>
					Rechercher
				</button>
			</div>
			</div>
		)
	}

	dispTotalCount() {
		return (
			<div className="row">
      <div className="col-12 text-center">
      	<br/>
				<span className="mqvnea-total-meters-title"> Mètres de la saison </span>
				<CountUp
				  start={0} end={this.state.yearTotalMeters} delay={0} duration={5}
				  separator=" " decimals={0} decimal="," prefix="" suffix=" m">
{/*
				  onEnd={() => console.log('Ended! 👏')}
				  onStart={() => console.log('Started! 💨')}>
*/}
				  {({ countUpRef }) => (
				    <div>
				      <span className="mqvnea-total-meters-number" ref={countUpRef} /><br/><br/>
				    </div>
				  )}
				</CountUp>
			</div>
			</div>
		)
	}

	displayModule() {
		if (this.state.loading) {
			return (this.displaySpinner());
		} else {
			return (this.state.mqYear.levels.map(this.displayDataLevel));
		}
	}

	displayDataLevel(level, levelIdx, mqYearLevels) {

		return (
			<div key={'dpl'+levelIdx} className="row row-margin-bottom-50">

			<div className="col-md-4 text-center margin-montqvnea-level-logo only-on-mobile">
				{(level.logo2) !== "" ?
					<img className="img-fluid" src={level.logo2} alt="leaders" width="300"/> : null}
			</div>

			<div className="col-md-8">
      <Card id={"card.level." + levelIdx}>
       	<CardHeader className="stateloListItemPointer noselect" onClick={this.toggleLevel.bind(this, levelIdx)}>
          <h5><i className="fa fa-angle-double-up"></i> {level.name} </h5>
          <p className="mqTitleMargin"> 
          	{level.nbPlayers} joueurs, {level.nbMeters} mètres
          </p>
        </CardHeader>

        {(!this.state.visibleLevels[levelIdx]) ?
        	<span className="mqEmptyLevelMsg"> Cliquer sur l'entête pour afficher ce niveau </span>
        	: null}

        <Collapse id={"collapse." + levelIdx}
          isOpen={this.state.visibleLevels[levelIdx]}
          onEntered={this.onLevelOpened.bind(this, levelIdx)}
          onExited={this.onLevelClosed.bind(this, levelIdx)}>

        <CardBody>
					<div className="row">
					<div className="col-md-3 text-center margin-montqvnea-level-logo">
						{(level.logo) !== "" ?
							<img className="img-fluid" src={level.logo} alt="leaders" width="120"/> : null}
					</div>
					<div className="col-md-9">
	
						<div className="table-responsive tableFixHeader tableFixHeader-montQvnea">
						<table className="table table-hover table-sm">
						<thead>
							<tr>
								{cstTableHeaders.map(this.createHdrRow.bind(this, levelIdx))}
							</tr>
						</thead>

						{this.displayTable(levelIdx)}
						</table>
						</div>
					</div>
					</div>
	      </CardBody>
	    	</Collapse>
{/*
	    	<CardFooter>
          <p>Footer</p>
	    	</CardFooter>
*/}
			</Card>
			</div>

			<div className="col-md-4 text-center margin-montqvnea-level-logo not-on-mobile">
				{(level.logo2) !== "" ?
					<img className="img-fluid" src={level.logo2} alt="leaders" width="300"/> : null}
			</div>
			</div>
		);
	}

	createHdrRow(level, hdrItem, hdrIdx) {

		var classNameStr = '';
		var onClickAction = function() {};

		// Sort with arrows
		// No sort on Rank (column 0)
		if (hdrIdx !== 0) {
			onClickAction = this.handleSortTable;
			classNameStr = 'statelo-sorting';
			if(hdrIdx === this.state.sortFieldIdxs[level]) {
				if (this.state.sortOrders[level] === "asc") {
					classNameStr += ' statelo-sorting_asc';
				} else {
					classNameStr += ' statelo-sorting_desc';
				}
			}
		}

		return (
			<th key={"colid." + level + '.' + hdrIdx} 
				id={"colid." + level + '.' + hdrIdx} 
				className={classNameStr}
				onClick={onClickAction}>
				{hdrItem}
			</th>
		);
	}

	displayTable(level) {
		var mqTableDataLevel = this.state.mqTableData[level];

		if (mqTableDataLevel.length === 0) {
			return (
				<tbody>
					<tr><td colSpan="99">Aucun participant à ce niveau</td></tr>
				</tbody>
			)
		} else {
			return (
				<tbody>
					{mqTableDataLevel.map(this.createTableRow.bind(this, level))}
				</tbody>
			)
		}
	}

  createTableRow(level, row, rowIdx, rows) {
/*
  	var highlightClassName = "";
  	if ((level === 4) && (rowIdx === 5)) {
			highlightClassName = "highlightTableRow";
  	}
*/
    return (
      <tr key={'tablerow.' + level + "." + rowIdx} id={'tablerow.' + level + "." + rowIdx}>
        <td> {rowIdx + 1} </td>
 				<td className="stateloListItemPointer" 
 					onClick={this.handleShowPlayerProgramsModal.bind(this, row[5], row[1])}> 
 					{row[1]} 
 				</td>
       	<td> {row[2]} </td>
        {/*<td> {row[3]} </td>*/}
        {/*<td> {row[4]} </td>*/}
      </tr>
    );
  }

	onLevelOpened(level) {
		// console.log('level: ' + level + ' collapse opened');
		// Create the event
		var event = new CustomEvent("collapse-shown", { "detail": "collapse-shown" });
		// Dispatch/Trigger/Fire the event
		document.dispatchEvent(event);
	}

	onLevelClosed(level) {
		//console.log('level ' + level + 'collapse closed');
	}

	handleYearChange(e) {
		var selectedYear = e.target.value;
		this.setState({
			selectedYear: selectedYear
		});		
 		this.loadLevels(this.state.mqYears, selectedYear);
	}

  handlePlayerChange(dataValue) {
		this.setState({
			playerSearchId: dataValue
		});
  }

	handleSearchPlayer(e) {
		var _this = this;
		var playerSearchId = this.state.playerSearchId;
		var visibleLevels = this.state.visibleLevels;

		Axios.get('/api/qvnea/montQvneaPlayerLevel/year/' + this.state.selectedYear + '/player/' + playerSearchId).then(function(response) {
	
			var playerData = response.data;

			// console.log('playerData');
			// console.log(playerData);
			
			if(playerData.playerLevel === -1) {
				alert("Ce joueur n'a cumulé aucun mètre pour la saison demandée");
			} else {
				_this.openLevel(playerData.playerLevel, playerSearchId);
			}
		});
	}

	handleSortTable(e) {
		var _this = this;
		var level = parseInt(e.target.id.split(".")[1], 10);
		var sortFieldIdx = parseInt(e.target.id.split(".")[2], 10);

		var mqTableData = this.state.mqTableData;
		var sortOrder = this.state.sortOrders[level];
		var prevSortFieldIdx = this.state.sortFieldIdxs[level];

		// Toggle sort order
		if (prevSortFieldIdx === sortFieldIdx) {
			if (sortOrder === 'asc') {
				sortOrder = 'desc';
			} else {
				sortOrder = 'asc';
			}
		} else {
			sortOrder = cstDefaultSortOrder[sortFieldIdx];
		}

		var sortFieldIdxs = this.state.sortFieldIdxs;
		var sortOrders = this.state.sortOrders;

		sortFieldIdxs[level] = sortFieldIdx;
		sortOrders[level] = sortOrder;

		this.sortLevel(this.state.mqTableData, this.state.selectedYear, level, sortFieldIdxs, sortOrders, "0");
	}

	handleShowPlayerProgramsModal(playerId, playerName) {
		var programsModalPlayer = {
			_id: playerId,
			name: playerName
		};

		this.setState({
			programsModalPlayer: programsModalPlayer,
			showPlayerProgramsModal: true
		});
	}

	handleModalCancel() {
		this.setState({ 
			showPlayerProgramsModal: false
		});
	}

	getAdminRightsInfo(callback) {
		var adminAccess = this.state.adminAccess;
		adminAccess.adminValidatedAccessLevel = 99;		// not used here

		if (this.state.isAuthenticated) {
			Users.getAccessLevel(this.state.profile, function(globalAccessLevel) {
				adminAccess.globalAccessLevel = globalAccessLevel;
				callback(adminAccess);
			});

		} else {
			adminAccess.globalAccessLevel = 99;
			callback(adminAccess);
		}
	}

	displaySpinner() {
		return (
  		<div className="sk-three-bounce">
    		<div className="sk-child sk-bounce1"></div>
    		<div className="sk-child sk-bounce2"></div>
    		<div className="sk-child sk-bounce3"></div>
  		</div>
  	);
	}

}

export default MontQvnea;
